// Action Creators
// Constants
import { PlanType } from "@ms/uno-constants/lib/local/AppConstants";
import { EngagementTelemetryConstants } from "@ms/uno-constants/lib/local/EngagementTelemetryConstants";
import { ModalType } from "@ms/uno-constants/lib/local/ModalType";
import { PlanLinkTelemetryComponentName } from "@ms/planner-models/lib/local/constants/PlanLinkConstants";
/** Opens linked-plan creation when the feature is enabled for a Unified source plan. */ export const openCreatePlanFromTaskModal = (isCreatePlanFromTaskEnabled, sourceTaskId, sourcePlan, modalActionCreator, telemetryEntryPoint, engagementLogger, onDismiss)=>{
    if (!isCreatePlanFromTaskEnabled || sourcePlan?.getPlanType() !== PlanType.Unified) {
        return;
    }
    const modalData = {
        modalType: ModalType.CreatePlan,
        showCreateNewPremium: false,
        sourceTaskId,
        sourcePlanId: sourcePlan.id,
        sourcePlanDisplayName: sourcePlan.displayName,
        telemetryEntryPoint,
        onDismiss
    };
    engagementLogger.logEngagement(PlanLinkTelemetryComponentName, EngagementTelemetryConstants.PLinkEntryPointClicked, {
        operation: "create-new",
        entryPoint: telemetryEntryPoint
    });
    modalActionCreator.openModal(modalData);
};
